import type { ReactNode } from 'react';
import { cn } from '@rhpc/ui';

interface PageShellProps {
  children: ReactNode;
  fill?: boolean;
  className?: string;
}

export function PageShell({ children, fill = false, className }: PageShellProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-[1280px]',
        fill && 'flex min-h-0 flex-1 flex-col overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  );
}

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        'mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-6',
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="text-h1 text-text">{title}</h1>
        {description != null && (
          <p className="mt-1.5 text-body text-text-2">{description}</p>
        )}
      </div>
      {actions != null && <div className="flex shrink-0 flex-wrap items-center gap-2.5">{actions}</div>}
    </div>
  );
}
